import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from './AuthProvider';
import { Spinner } from '@/components/ui/spinner';

type Area = 'advertiser' | 'admin';

export function ProtectedRoute({ area, children }: { area: Area; children: ReactNode }) {
  const { ready, authenticated, isAdvertiser, isAdmin } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner label="Loading Fasto Ads…" />
      </div>
    );
  }

  if (!authenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (area === 'advertiser' && !isAdvertiser) {
    // A team member landed on an advertiser route — send them to admin.
    return <Navigate to="/admin" replace />;
  }
  if (area === 'admin' && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
